// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueTouch from 'vue-touch'
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
  Style,
  Button,
  Loading,
  Popup,
  Toast,
  ImagePreview,
  ActionSheet,
  Dialog
} from 'cube-ui'
import App from './App'
import router from './router'
import store from './controller/index'

// import VConsole from 'vconsole'
// Vue.use(new VConsole())

Vue.use(Button)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(ImagePreview)
Vue.use(ActionSheet)
Vue.use(Dialog)

Vue.use(VueTouch, { name: 'v-touch' })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js